import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';

import AsideItem from '../aside_item';

const AdminMenu = ({
  nurseTeleconsultationsCount,
  children,
  firstTeleconsultationsCount,
  location,
  polygraphiesCount,
  polysomnographiesCount,
  renewalsCount,
  secondTeleconsultationsCount,
  tasksCount,
  treatmentsCount,
}) => {
  return (
    <section className="th-nav-body">
      <div className="th-nav-top">
        <ul className="th-nav-list th-nav-manage">
          <li className="th-nav-list-h">Pipeline</li>
          <AsideItem
            count={nurseTeleconsultationsCount}
            label="Nurse teleconsultations"
            active={location.pathname === '/nurse_teleconsultations'}
            primaryAction="/nurse_teleconsultations"
          />
          <AsideItem
            count={firstTeleconsultationsCount}
            label="1st teleconsultations"
            active={location.pathname === '/first_teleconsultations'}
            primaryAction="/first_teleconsultations"
          />
          <AsideItem
            count={polygraphiesCount}
            label="Polygraphies"
            active={location.pathname === '/polygraphies'}
            primaryAction="/polygraphies"
          />
          <AsideItem
            count={polysomnographiesCount}
            label="Polysomnographies"
            active={location.pathname === '/polysomnographies'}
            primaryAction="/polysomnographies"
          />
          <AsideItem
            count={secondTeleconsultationsCount}
            label="2nd teleconsultations"
            active={location.pathname === '/second_teleconsultations'}
            primaryAction="/second_teleconsultations"
          />
          <AsideItem
            label="Treatments"
            count={treatmentsCount}
            active={location.pathname === '/treatments'}
            primaryAction="/treatments"
          />
          <AsideItem
            count={renewalsCount}
            label="Renewals"
            active={location.pathname === '/renewals'}
            primaryAction="/renewals"
          />
        </ul>
        <ul className="th-nav-list th-nav-manage">
          <li className="th-nav-list-h">Manage</li>
          <AsideItem
            label="Doctors"
            active={location.pathname === '/doctors'}
            primaryAction="/doctors"
            secondaryAction="/doctors/add"
          />
          <AsideItem
            label="Technicians"
            active={location.pathname === '/technicians'}
            primaryAction="/technicians"
            secondaryAction="/technicians/add"
          />
          <AsideItem
            label="PSAD reps"
            active={location.pathname === '/psad_reps'}
            primaryAction="/psad_reps"
            secondaryAction="/psad_reps/add"
          />
          <AsideItem
            label="Customers"
            active={location.pathname === '/customers'}
            primaryAction="/customers"
          />
          <AsideItem
            count={tasksCount}
            label="Tasks"
            active={location.pathname === '/tasks'}
            primaryAction="/tasks"
          />
          <AsideItem
            label="Responses"
            active={location.pathname === '/responses'}
            primaryAction="/responses"
          />
        </ul>
      </div>
      {children}
    </section>
  );
};

AdminMenu.propTypes = {
  nurseTeleconsultationsCount: PropTypes.number,
  children: PropTypes.node,
  firstTeleconsultationsCount: PropTypes.number,
  location: ReactRouterPropTypes.location.isRequired,
  polygraphiesCount: PropTypes.number,
  renewalsCount: PropTypes.number,
  secondTeleconsultationsCount: PropTypes.number,
  tasksCount: PropTypes.number,
  treatmentsCount: PropTypes.number,
};

export default withRouter(AdminMenu);
